/** True when locale is missing or primary language is English. */
export function isEnglishQuestionLocale(locale: string | null | undefined): boolean {
  if (locale == null || String(locale).trim() === '') {
    return true;
  }
  const primary = String(locale).toLowerCase().split(/[-_]/)[0];
  return primary === 'en';
}
